export class ErrorResponse {
  CustomErrorMessage = 'אירעה שגיאה';
  constructor(message: string) {
    this.CustomErrorMessage = message;
  }
}
